//This will be called on client and server side.
import { getImagePathByTagName } from './ImagePathHelper';
import { getImagesDimentionByResolution } from './ImagesDimensionHelper';
import { GetImageURLProps, SUPPORTED_IMAGE_TYPE } from './SupportedImageTypes';
import { isServer } from '../common';
import {
  CLOUDINARY_AUTO_IMAGE_URL_PARAMS,
  CLOUDINARY_AUTO_IOS_IMAGE_URL_PARAMS,
  CLOUDINARY_AVIF_IMAGE_URL_PARAMS,
  CLOUDINARY_IMAGE_URL,
  CLOUDINARY_WEBP_IMAGE_URL_PARAMS
} from '../constants/ApiConstants';
import { CONSUMPTION_PAGES } from '../constants/ConsumptionPagesConstants';
import { INBUILT_DATA_TYPES } from '../constants/stringConstants';
import { TAG_NAME } from '../constants/TagNameConstants';

enum ImageCompatibleTypes {
  AVIF = 'AVIF',
  WEBP = 'WEBP'
}

const checkAvifCompatibleOnServer = () => {
  const globalServer = global as typeof globalThis & {
    AVIF_COMPATIBLE: boolean;
  };
  return !!globalServer.AVIF_COMPATIBLE;
};
const checkWebpCompatibleOnServer = () => {
  const globalServer = global as typeof globalThis & {
    WEBP_COMPATIBLE: boolean;
  };
  return !!globalServer.WEBP_COMPATIBLE;
};
export const getWebPImageURLParams = (
  compatibleType: ImageCompatibleTypes = ImageCompatibleTypes.AVIF
) => {
  if (compatibleType === ImageCompatibleTypes.AVIF) {
    const isAvifCompatible = isServer()
      ? checkAvifCompatibleOnServer()
      : window.isAvifCompatible;
    if (isAvifCompatible) {
      return CLOUDINARY_AVIF_IMAGE_URL_PARAMS;
    }
  }
  const isWebPCompatible = isServer()
    ? checkWebpCompatibleOnServer()
    : window.isWebPCompatible;
  let imageURLParams = CLOUDINARY_WEBP_IMAGE_URL_PARAMS;
  if (!isWebPCompatible) {
    imageURLParams =
      !isServer() && window.isSafari
        ? CLOUDINARY_AUTO_IOS_IMAGE_URL_PARAMS
        : CLOUDINARY_AUTO_IMAGE_URL_PARAMS;
  }
  return imageURLParams;
};

const scaleImageDimension = (imageUrl: string) => {
  const regex = /w_(\d+),h_(\d+)/;

  // Extracting width and height values using match
  const match = imageUrl.match(regex);

  if (match) {
    const width = Math.ceil(+match[1] * 1.5); // width value
    const height = Math.ceil(+match[2] * 1.5); // height value
    imageUrl = imageUrl.replace('w_' + match[1], 'w_' + width);
    imageUrl = imageUrl.replace('h_' + match[2], 'h_' + height);
    return imageUrl;
  }
  return imageUrl;
};

export const reduceImageDimension = (imageUrl: string) => {
  const regex = /w_(\d+),h_(\d+)/;

  // Extracting width and height values using match
  const match = imageUrl.match(regex);

  if (match) {
    const width = Math.ceil(+match[1] / 1.5); // width value
    const height = Math.ceil(+match[2] / 1.5); // height value
    imageUrl = imageUrl.replace('w_' + match[1], 'w_' + width);
    imageUrl = imageUrl.replace('h_' + match[2], 'h_' + height);
    return imageUrl;
  }
  return imageUrl;
};

export const getImageURL = (props: GetImageURLProps) => {
  const { deviceWidth, isRequestedByBot, tagName, item } = props;

  // Return image if item.image data type is string, this case is specific to lang and genre rails, were API response is different as item.image is string instead of object.
  if (typeof item.image === INBUILT_DATA_TYPES.STRING) {
    // This item.image represents the actual URL of the image
    return item.image as string;
  }
  const {
    NEWS_TITLE,
    PORTRAIT,
    PORTRAIT_SMALL,
    COVER,
    APP_COVER,
    PORTRAIT_LARGE
  } = TAG_NAME;

  const imageParams = getWebPImageURLParams(
    isRequestedByBot ? ImageCompatibleTypes.WEBP : ImageCompatibleTypes.AVIF
  );

  let imageType = SUPPORTED_IMAGE_TYPE.JPG;
  if (tagName === CONSUMPTION_PAGES.CHANNEL) {
    imageType = SUPPORTED_IMAGE_TYPE.PNG;
  }

  const imageDimensionObj = getImagesDimentionByResolution(deviceWidth);
  const imageURLPath =
    getImagePathByTagName(tagName) || getImagePathByTagName(NEWS_TITLE);

  const tagDimension =
    tagName in imageDimensionObj
      ? imageDimensionObj[tagName as keyof typeof imageDimensionObj]
      : imageDimensionObj.newsTitle;

  let url = '';

  if (
    tagName === TAG_NAME.ZEE5MUSIC ||
    tagName === TAG_NAME.ZEE5MUSICENTRYPOINTBANNER
  ) {
    url = `${CLOUDINARY_IMAGE_URL}w_${tagDimension[0]},h_${
      tagDimension[1]
    }${imageParams}${item.id}/${getImagePathByTagName(tagName)?.path}/${
      item.image[getImagePathByTagName(tagName)?.name as keyof typeof Image] ||
      item?.image?.sticker
    }${imageType}`;
    return url;
  }

  //TODO: Refine if/else check of tagName and assetType check
  if (
    item.assetType &&
    item.assetType === 101 &&
    tagName !== TAG_NAME.CONTINUE_WATCHING &&
    tagName !== TAG_NAME.COLLECTION
  ) {
    if (deviceWidth < 900 && imageURLPath.path === COVER) {
      //TODO: there is no APP_COVER in predefined image path. Need to check logic later.
      imageURLPath.path = APP_COVER;
    }
    if (tagName === PORTRAIT_SMALL || tagName === PORTRAIT_LARGE) {
      imageURLPath.path = PORTRAIT;
    }

    url = `${CLOUDINARY_IMAGE_URL}w_${tagDimension[0]},h_${
      tagDimension[1]
    }${imageParams}${item.id}/${imageURLPath.path}/${
      item.image[getImagePathByTagName(tagName)?.name as keyof typeof Image]
    }${imageType}`;
    return url;
  }

  if (item.image) {
    url = `${CLOUDINARY_IMAGE_URL}w_${tagDimension[0]},h_${
      tagDimension[1]
    }${imageParams}${item.id}/${imageURLPath.path}/${
      item.image[getImagePathByTagName(tagName)?.name as keyof typeof Image]
    }${imageType}`;
  }
  // } else if (item?.image_url) {
  //   url = item.image_thumbnail;
  // }
  url = scaleImageDimension(url);
  return url;
};
